module.exports = __webpack_public_path__ + "static/media/excel.cb7f7670.svg";